import { useState, useEffect, useContext, useRef } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import HospitalCustomPaginaion from "../../utils/HospitalPaginationUtil";
import { logOut } from "../../config/user";
import { fetchCommentCount } from "../../redux/notificationSlice";
import { CircularProgress } from "@mui/material";
import { CommentServices } from "../../services/CommentServices";
import { AuthServices } from "../../services/AuthServices";
import { PreinitiateServices } from "../../services/PreinitiateServices";
import CloseIcon from "../../assets/hospitalCloseIcon.svg";
import DownloadIcon from "../../assets/downloadIconGreen.svg";
import RotateLeft from "../../assets/rotate-left.svg";
import RotateRight from "../../assets/rotate-right.svg";
import Crop from "../../assets/crop.svg";
import RightArrow from "../../assets/rightArrowWhite.svg";
import SpeakerIcon from "../../assets/speakerIcon.svg";
import CcChatCheck from "../../assets/CcChatCheck.svg";
import CrossIcon from "../../assets/crossIcon.svg";
import ReuploadImageIcon from "../../assets/reUploadImageIcon.png";
import CallIcon from "../../assets/call filled.svg";
import SendIcon from "../../assets/sendIcon.svg";
import RiskIcon from "../../assets/riskIcon.svg";
import HighRiskText from "../../assets/HighRiskText.svg";
import SpeechToText from "../../assets/speechToText.svg";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { docUploadRefreshContext } from "../../dashboard/cases/contexts/CaseContexts";
import html2canvas from "html2canvas";
import { getUser } from "../../config/user";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { useSelector, useDispatch } from "react-redux";
import { CaseServices } from "../../services/CaseServices";
import { Close } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";

const ImagesGalleryHospitalPersona = ({
  data,
  setData,
  setOpen,
  selectedImage,
  view,
  type,
  getDocumentsData,
  documentId,
}) => {
  const [imageState, setImageState] = useState({
    image: "",
    brightness: 100,
    grayscale: 0,
    sepia: 0,
    saturate: 100,
    contrast: 100,
    hueRotate: 0,
    rotate: 0,
    vertical: 1,
    horizontal: 1,
  });
  const [selectedFilter, setSelectedFilter] = useState({
    name: "",
    maxValue: "",
  });
  const [crop, setCrop] = useState(null);
  const [details, setDetails] = useState(null);
  const [docDetails, setDocDetails] = useState(null);
  const [riskData, setRiskData] = useState(null);
  const [openRiskModal, setOpenRiskModal] = useState(false);
  const [users, setUsers] = useState(null);
  const [message, setMessage] = useState("");
  const [ccChecked, setCcChecked] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [reUploading, setReuploading] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(() =>
    Number.isInteger(selectedImage) ? selectedImage + 1 : 1,
  );
  const [currentCommentId, setCurrentCommentId] = useState(null);
  const [enlargeImage, setEnlargeImage] = useState(null);
  const [currentWordIndex, setCurrentWordIndex] = useState(-1);
  const [startId, setStartId] = useState(null);
  const [endId, setEndId] = useState(null);

  const [deletedDocsData, setDeletedDocsData] = useState(null);
  const [loadingDeletedDocs, setLoadingDeletedDocs] = useState(false);

  const dispatch = useDispatch();
  const endOfMessagesRef = useRef(null);
  const { messageId } = useSelector((store) => store.notificationReducer);
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
  // const referenceContext = useContext(docUploadRefreshContext);
  const reUploadFileRef = useRef();
  const handleReUploadButtonClick = () => {
    reUploadFileRef.current.click();
  };
  const handleSelect = (i) => {
    if (startId === null) {
      setStartId(i);
    } else if (endId === null) {
      setEndId(i);
    } else {
      // reset selection if clicked third time
      setStartId(i);
      setEndId(null);
    }
  };

  const user = getUser();

  // NEW: single source of truth for "what am I currently rendering" —
  // either the deleted-docs response, or the live `data` prop.
  const activeData = deletedDocsData || data;
  const isViewingHistory = Boolean(deletedDocsData);

  const filterValue = [
    {
      name: "brightness",
      maxValue: "200",
    },
    {
      name: "grayscale",
      maxValue: "200",
    },
    {
      name: "sepia",
      maxValue: "200",
    },
    {
      name: "saturate",
      maxValue: "200",
    },
    {
      name: "contrast",
      maxValue: "200",
    },
    {
      name: "hueRotate",
      maxValue: "200",
    },
  ];

  const defaultRisks = async () => {
    try {
      const res = await CommentServices.getDefaultRisks();
      setRiskData(res?.data?.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const reUploadImage = async (e) => {
    // Guard: re-uploading only makes sense for live (non-deleted) documents.
    if (isViewingHistory) return;
    setReuploading(true);
    try {
      let formData = new FormData();
      formData.append("image", e.target.files[0]);
      let res = await AuthServices.uploadImage(formData);
      data[currentIndex - 1].documentUrl = res?.data?.url;
      type === "document"
        ? await CaseServices.saveDocumentUrl(documentId, [
            {
              ...data[currentIndex - 1],
              documentUrl: res?.data?.url,
              urlId: data[currentIndex - 1].id,
            },
          ])
        : await PreinitiateServices.updateReferenceDocument(
            {
              documentUrl: res?.data?.url,
            },
            selectedDoc.id,
          );
      window.alert("Image uploaded successfully");
      await getDocumentsData();
    } catch (error) {
      if (error?.response?.status === 401) {
        logOut();
      } else {
        handleApiErrorResponses(error);
      }
    }
    setReuploading(false);
  };

  const getUsers = async () => {
    try {
      const res = await CommentServices.getAllUserDetail();
      setUsers(res?.data?.users);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const getDocComments = async (docId) => {
    try {
      const id = docId ?? activeData?.[currentIndex - 1]?.id;
      if (!id) return;
      const res = await CommentServices.getDocumentComments(
        type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
        id,
      );
      setDocDetails(res?.data?.documentDetails);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleReadCcCommentNotification = async (documentId) => {
    let comment =
      docDetails?.comments?.length > 0
        ? docDetails?.comments[docDetails?.comments?.length - 1]
        : null;
    if (
      !comment ||
      !users[comment.from].role?.toLowerCase()?.includes("hospital")
    ) {
      return;
    }
    try {
      if (user?.roles[0]?.roleId !== 1 && user?.roles[0]?.roleId !== 2) {
        await CommentServices.readDocCommentNotification(documentId);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleCommentAdd = async () => {
    // Guard: deleted documents are read-only history, not commentable.
    if (isViewingHistory) return;
    if (message) {
      try {
        const commentData = {
          documentId: activeData[currentIndex - 1].id,
          message: message,
          commentOn: type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
        };
        await CommentServices.sendComment(commentData);
        await handleReadCcCommentNotification(activeData[currentIndex - 1].id);
        setMessage("");
        await getDocComments();
      } catch (error) {
        handleApiErrorResponses(error);
      }
    }
  };

  const handleRiskCommentAdd = async (riskData) => {
    if (isViewingHistory) return;
    try {
      let userInput = prompt("Enter Procedure Code that HSA suggested.");
      if (userInput) {
        const commentData = {
          documentId: activeData[currentIndex - 1].id,
          message: riskData.message + `(code: ${userInput})`,
          procedureCode: userInput,
          riskResponse: riskData?.riskResponse,
          riskType: riskData?.riskType,
          commentOn: type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
        };
        await CommentServices.sendComment(commentData);
        await handleReadCcCommentNotification(activeData[currentIndex - 1].id);
        await getDocComments();
      }
      setOpenRiskModal(false);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleCodeCommentAdd = async (message, comment) => {
    if (isViewingHistory) return;
    try {
      const commentData = {
        documentId: activeData[currentIndex - 1].id,
        message: comment ? message + ` ${comment?.procedureCode}` : message,
        commentOn: type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
      };
      await CommentServices.sendComment(commentData);
      await handleReadCcCommentNotification(activeData[currentIndex - 1].id);
      setOpenRiskModal(false);
      await getDocComments();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleCallButtonClick = async () => {
    if (isViewingHistory) return;
    const text = `Welcome to Settlemed!
Thank you for reaching out. Your call request has been received.
We appreciate your patience—our Command Centre team will get back to you shortly via the Settlemed mobile application.

If you haven’t downloaded the app yet, please do so to stay connected and ensure smooth communication.`;

    try {
      const commentData = {
        documentId: activeData[currentIndex - 1].id,
        message: "Kindly give me a call back at your earliest convenience",
        commentOn: type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
      };
      await CommentServices.sendComment(commentData);
      await handleReadCcCommentNotification(activeData[currentIndex - 1].id);
      await getDocComments();

      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = "en-US";
      utterance.rate = 1.5;

      window.speechSynthesis.speak(utterance);
      window.alert(text);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const getDeletedDocs = async () => {
    setLoadingDeletedDocs(true);
    try {
      const res = await CaseServices?.getDeletedDocUrls(documentId);
      // Adjust this line if the actual response shape differs.
      const deletedDocs = res?.data?.doc?.documenturlmasters ?? null;

      setDeletedDocsData(deletedDocs);
      setCurrentIndex(1);
      setCcChecked(false);

      if (deletedDocs && deletedDocs?.length) {
        await getDocComments(deletedDocs[0].id);
      } else {
        // setDocDetails(null);
        toast?.info("No history present for this document");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setLoadingDeletedDocs(false);
    }
  };

  // NEW: switch back from history mode to the live `data` prop.
  const viewCurrentChat = async () => {
    setDeletedDocsData(null);
    setCurrentIndex(1);
    setCcChecked(false);
    if (data?.length) {
      await getDocComments(data[0]?.id);
    } else {
      setDocDetails(null);
    }
  };

  const handleCCfilter = async () => {
    if (ccChecked) {
      setCcChecked(false);
      await getDocComments();
    } else {
      const filteredComments = docDetails.comments?.filter(
        (comment) =>
          !users[comment.from].role?.toLowerCase()?.includes("hospital"),
      );
      docDetails.comments = filteredComments;
      setDocDetails({ ...docDetails });
      setCcChecked(true);
    }
  };

  const markReadNotification = async () => {
    try {
      await CommentServices.markNotificationReadByDocId(
        activeData[currentIndex - 1].id,
      );
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const updateViewDetail = async () => {
    try {
      const res = await CommentServices.updateViewDetail({
        documentId: activeData[currentIndex - 1].id,
        commentOn: type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
      });
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleSpeak = (text, commentId) => {
    if (!window.speechSynthesis) {
      alert("Speech Synthesis not supported in your browser");
      return;
    }

    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.rate = 1;

    const words = text.split(/\s+/);
    setCurrentCommentId(commentId);
    setCurrentWordIndex(-1);
    utterance.onboundary = (event) => {
      if (event.name === "word") {
        const charIndex = event.charIndex;
        let currentCharCount = 0;

        for (let i = 0; i < words.length; i++) {
          currentCharCount += words[i].length + (i < words.length - 1 ? 1 : 0);

          if (charIndex < currentCharCount) {
            setCurrentWordIndex(i);
            break;
          }
        }
      }
    };

    utterance.onend = () => {
      setCurrentWordIndex(-1);
      setCurrentCommentId(null);
    };

    utterance.onerror = (event) => {
      console.error("SpeechSynthesis error:", event);
      setCurrentWordIndex(-1);
      setCurrentCommentId(null);
    };

    window.speechSynthesis.speak(utterance);
  };

  const stopSpeaking = () => {
    window.speechSynthesis.cancel();
    setCurrentWordIndex(-1);
    setCurrentCommentId(null);
  };

  useEffect(() => {
    return () => {
      window.speechSynthesis.cancel();
    };
  }, []);

  const getFormattedDate = (isoString) => {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  };

  const imageCrop = () => {
    if (isViewingHistory) return; // read-only in history mode
    const canvas = document.createElement("canvas");
    const scaleX = details.naturalWidth / details.width;
    const scaleY = details.naturalHeight / details.height;
    canvas.width = crop.width;
    canvas.height = canvas.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      details,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height,
    );
    canvas.toBlob((blob) => {
      if (blob) {
        const blobUrl = URL.createObjectURL(blob);
        data[currentIndex - 1].documentUrl = blobUrl;
        setData([...data]);
      }
    });
  };

  const applyFilter = () => {
    if (isViewingHistory) return; // read-only in history mode
    const canvas = document.createElement("canvas");

    canvas.width = details?.naturalWidth;
    canvas.height = details?.naturalHeight;
    const ctx = canvas.getContext("2d");

    ctx.filter = `brightness(${imageState.brightness}%) sepia(${imageState.sepia}%) saturate(${imageState.saturate}%) contrast(${imageState.contrast}%) grayscale(${imageState.grayscale}%) hue-rotate(${imageState.hueRotate}deg)`;
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate((imageState.rotate * Math.PI) / 180);
    ctx.scale(imageState.vertical, imageState.horizontal);

    ctx.drawImage(
      details,
      -canvas.width / 2,
      -canvas.height / 2,
      canvas.width,
      canvas.height,
    );
    canvas.toBlob((blob) => {
      if (blob) {
        const blobUrl = URL.createObjectURL(blob);
        data[currentIndex - 1].documentUrl = blobUrl;
        setData([...data]);
      }
    });
    window.alert("Image Modified");
    setOpen(false);
  };

  const handleNextClick = () => {
    if (currentIndex < activeData.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 1) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "ArrowRight") {
      handleNextClick();
    } else if (event.key === "ArrowLeft") {
      handlePrevClick();
    }
  };

  const textareaRef = useRef(null);
  const LINE_HEIGHT = 20;
  const MAX_LINES = 4;
  const MIN_LINES = 1;

  const adjustTextareaHeight = () => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = "auto";

    const maxHeight = LINE_HEIGHT * MAX_LINES;
    const minHeight = LINE_HEIGHT * MIN_LINES;

    const newHeight = Math.min(Math.max(el.scrollHeight, minHeight), maxHeight);
    el.style.height = `${newHeight}px`;

    el.style.overflowY = el.scrollHeight > maxHeight ? "auto" : "hidden";
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, [message]);

  useEffect(() => {
    if (view) {
      getUsers();
      getDocComments();
      markReadNotification();
      dispatch(fetchCommentCount());
      defaultRisks();
    }
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  // UPDATED: this effect drives paging through whichever dataset is active
  // (live data or deleted-docs history) — getDocComments() with no arg reads
  // activeData[currentIndex - 1].id internally.
  useEffect(() => {
    if (view) {
      getDocComments();
      !isViewingHistory && markReadNotification();
      // markReadNotification();
      dispatch(fetchCommentCount());
    }
  }, [currentIndex, messageId]);

  useEffect(() => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: "smooth" });
    }
    if (view) {
      !isViewingHistory && updateViewDetail();
    }
  }, [docDetails]);

  useEffect(() => {
    if (Number.isInteger(selectedImage)) {
      setCurrentIndex(selectedImage + 1);
    }
  }, [selectedImage]);

  const currentDoc = activeData?.[currentIndex - 1];
  const currentDocUrl = currentDoc?.documentUrl || "";
  const isPdfDocument = (() => {
    const urlPath = String(currentDocUrl).split("?")[0].split("#")[0];
    const description = String(
      currentDoc?.description || currentDoc?.fileName || "",
    );
    const mime = String(
      currentDoc?.mimeType || currentDoc?.fileType || "",
    ).toLowerCase();
    return (
      /\.pdf$/i.test(urlPath) ||
      /\.pdf$/i.test(description) ||
      mime.includes("pdf")
    );
  })();

  return (
    <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-[#017C5780] z-[1201]">
      <div className="relative bg-white rounded-[16px] w-[90%] h-[90%] p-4 xl:p-8">
        <div className="absolute flex items-center gap-2 top-0 right-0  cursor-pointer">
          <div
            className="underline text-sm cursor-pointer"
            onClick={isViewingHistory ? viewCurrentChat : getDeletedDocs}
          >
            {loadingDeletedDocs
              ? "Loading..."
              : isViewingHistory
                ? "View Current Chat"
                : "View Chat History"}
          </div>
          <a
            href={activeData[currentIndex - 1]?.documentUrl}
            download
            className="cursor-pointer"
          >
            <img src={DownloadIcon} alt="download-icon" />
          </a>

          <img
            src={CloseIcon}
            alt="close-icon"
            onClick={async () => {
              setOpen(-1);
              view && (await getDocumentsData());
            }}
          />
        </div>

        <div className="text-black flex justify-center items-stretch gap-4 xl:gap-6 h-[90%] mt-2">
          {!view && (
            <div className="w-[40%]">
              <div className="text-[28px] 2xl:text-[33px] -tracking-[7%] mb-1 px-2">
                Document Preview
              </div>
              <div
                style={{ borderTop: "1px solid #E8E8E8", marginBlock: "25px" }}
              />{" "}
              <div className="flex  flex-wrap  h-[30%] w-full  p-1">
                {filterValue?.map((filter, idx) => {
                  return (
                    <div
                      key={idx}
                      className="w-full flex justify-between items-center"
                    >
                      <label className="w-[20%] text-[13px] 2xl:text-[15px] text-[#0B0B0B] -tracking-[5%] capitalize">
                        {filter.name}
                      </label>
                      <input
                        type="range"
                        name={filter.name}
                        value={imageState[filter.name]}
                        max={filter?.maxValue}
                        onChange={(e) =>
                          setImageState({
                            ...imageState,
                            [e.target.name]: e.target.value,
                          })
                        }
                        className="w-[80%] accent-[#017C71]"
                      />
                    </div>
                  );
                })}
              </div>
              {selectedFilter?.name && (
                <div className="flex items-center justify-between mt-2 px-2">
                  {" "}
                  <label className="text-black capitalize">
                    {selectedFilter.name}
                  </label>
                  <input
                    type="range"
                    name={selectedFilter.name}
                    value={imageState[selectedFilter.name]}
                    max={selectedFilter?.maxValue}
                    onChange={(e) =>
                      setImageState({
                        ...imageState,
                        [e.target.name]: e.target.value,
                      })
                    }
                  />
                </div>
              )}
              <div
                style={{ borderTop: "1px solid #E8E8E8", marginBlock: "25px" }}
              />
              <div className="w-[130px] text-[13px] 2xl:text-[15px] -tracking-[5%] capitalize">
                <div className="flex justify-between items-center">
                  <div>Rotate left</div>
                  <img
                    src={RotateLeft}
                    alt="rotate-left"
                    onClick={() =>
                      setImageState({
                        ...imageState,
                        rotate: imageState.rotate - 90,
                      })
                    }
                  />
                </div>
                <div className="flex justify-between items-center mt-7">
                  <div>Rotate right</div>
                  <img
                    src={RotateRight}
                    alt="rotate-right"
                    onClick={() =>
                      setImageState({
                        ...imageState,
                        rotate: imageState.rotate + 90,
                      })
                    }
                  />
                </div>
              </div>
              <div
                className="w-fit flex items-center gap-5 text-xs 2xl:text-sm text-white bg-[#017C71] leading-[21.7px] -tracking-[3%] mt-10 px-5 2xl:px-6 py-3 2xl:py-4 rounded-full"
                onClick={applyFilter}
              >
                Save{" "}
                <img src={RightArrow} alt="right-arrow" onClick={applyFilter} />
              </div>
            </div>
          )}
          <div
            className={`h-full flex justify-center min-w-0 ${
              view ? "w-[55%] 2xl:w-[50%]" : "w-[70%]"
            }`}
          >
            <div
              className={`relative flex flex-col items-center ${
                isPdfDocument ? "h-full w-full" : "h-auto w-auto"
              }`}
            >
              {/* Tooltip / Rejection reason */}
              {activeData[currentIndex - 1]?.status === "REJECTED" &&
                type !== "document" && (
                  <div className="absolute top-2 left-1/2 -translate-x-1/2 z-[1500]">
                    <Tooltip
                      title={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "pre-line",
                            wordBreak: "break-word",
                          }}
                        >
                          {activeData[currentIndex - 1]?.rejectionReason}
                        </Typography>
                      }
                      arrow
                      placement="top"
                    >
                      <div className="bg-red-600 text-black px-4 py-2 rounded font-bold text-base shadow-lg border-b-2 border-red-800 max-w-xs cursor-help overflow-hidden text-ellipsis whitespace-nowrap">
                        Rejection Reason:&nbsp;
                        {activeData[currentIndex - 1]?.rejectionReason}
                      </div>
                    </Tooltip>
                  </div>
                )}
              {/* Image or PDF preview (classification may return PDFs) */}
              {isPdfDocument ? (
                <iframe
                  key={currentDocUrl}
                  src={`${currentDocUrl}#toolbar=1&navpanes=0&scrollbar=1&view=FitH`}
                  title={
                    currentDoc?.description ||
                    currentDoc?.fileName ||
                    "document-pdf"
                  }
                  style={{ width: "100%", height: "100%", minHeight: "75vh" }}
                  className="shadow-2xl rounded-[8px] border-0 bg-white"
                />
              ) : (
                <img
                  src={currentDocUrl}
                  onLoad={(e) => setDetails(e.currentTarget)}
                  id="image"
                  style={{
                    filter: `brightness(${imageState.brightness}%) sepia(${imageState.sepia}%) saturate(${imageState.saturate}%) contrast(${imageState.contrast}%) grayscale(${imageState.grayscale}%) hue-rotate(${imageState.hueRotate}deg)`,
                    transform: `rotate(${imageState.rotate}deg)`,
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                  className="object-contain h-full w-full shadow-2xl rounded-[8px] cursor-pointer"
                  alt="document-img"
                />
              )}
              {!isViewingHistory &&
                !isPdfDocument &&
                activeData[currentIndex - 1]?.status === "REJECTED" && (
                  <div className="absolute h-[100%] w-[100%] top-0 left-0 flex items-center justify-center bg-[#FFD6DB80] rounded-[15px]">
                    {" "}
                    {reUploading ? (
                      <CircularProgress />
                    ) : (
                      <img
                        src={ReuploadImageIcon}
                        alt="re-upload-image"
                        className="absolute top-[80%] cursor-pointer"
                        onClick={() => {
                          handleReUploadButtonClick();
                          setSelectedDoc(activeData[currentIndex - 1]);
                        }}
                      />
                    )}
                  </div>
                )}
            </div>
          </div>

          {view && (
            <div
              style={{ border: "1px solid #F0F0F0", boxSizing: "border-box" }}
              className="relative h-full rounded-[30px] w-[42%] 2xl:w-[45%] p-2 shrink-0"
            >
              <div
                style={{ boxSizing: "border-box" }}
                className="absolute top-0 left-0 w-full bg-white flex justify-between items-center px-[10px] py-[16px] mb-2 rounded-t-[30px] z-1"
              >
                <div className="text-[24px] text-[#191919] font-medium">
                  {isViewingHistory ? "Chat History" : "Chat box"} (
                  {docDetails && (docDetails?.comments?.length || 0)})
                </div>
                <div className="flex  items-center gap-[10px] mr-5">
                  {!isViewingHistory && (
                    <img
                      src={CallIcon}
                      alt="call-icon"
                      className="cursor-pointer"
                      onClick={handleCallButtonClick}
                    />
                  )}
                </div>
              </div>
              <div className="h-[72%] 2xl:h-[82%] flex flex-col  overflow-y-scroll mt-12 ">
                {docDetails &&
                  docDetails?.comments?.map((comment, idx) => {
                    return (
                      <div
                        key={idx}
                        className={`chat-msg cursor-pointer p-1 rounded-md `}
                        onClick={() => handleSelect(idx)}
                      >
                        {" "}
                        {user?.user?.id === comment?.from ? (
                          <div key={idx} className="flex justify-end mt-[10px]">
                            <div className="max-w-[87%] min-w-[30%] text-[#0B0B0B] p-[10px] bg-[#dcf8c6] rounded-[20px]">
                              <div className="flex items-center justify-between">
                                <div className="flex flex-row-reverse items-center gap-[10px]">
                                  <div className="w-[33px] h-[33px] flex justify-center items-center text-[#0B0B0B] text-[20px] bg-white rounded-full">
                                    U
                                  </div>
                                  <div className="text-[15px] font-medium">
                                    You
                                  </div>
                                </div>
                                <div className="flex items-center gap-[20px] px-[10px]">
                                  <div className="text-[10px] text-[#969696]">
                                    {getFormattedDate(comment.createdAt)}
                                    <DoneAllOutlinedIcon
                                      style={{
                                        color:
                                          comment?.views?.length >=
                                          comment?.to?.length
                                            ? "#00ccff"
                                            : "",
                                        fontSize: "14px",
                                        marginLeft: "8px",
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <img
                                      src={SpeakerIcon}
                                      alt="speaker-icon"
                                      className="cursor-pointer w-4 h-4"
                                      onClick={() =>
                                        handleSpeak(comment.message, idx)
                                      }
                                      onKeyDown={(e) =>
                                        e.key === "Enter" &&
                                        handleSpeak(comment.message, idx)
                                      }
                                      role="button"
                                      tabIndex={0}
                                    />
                                  </div>
                                </div>
                              </div>
                              {comment?.riskType ? (
                                <div className="flex gap-2 items-start  mt-3">
                                  <div className="w-[40%]">
                                    <img
                                      src={HighRiskText}
                                      alt="high-risk-text-icon"
                                      className="w-full h-auto object-contain"
                                    />
                                  </div>
                                  <div className="w-[100%]  text-xs pl-[10px] leading-[15px]">
                                    {comment?.message
                                      .split(/\s+/)
                                      .map((word, wordIdx) => (
                                        <span
                                          key={wordIdx}
                                          style={{
                                            backgroundColor:
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "yellow"
                                                : "transparent",
                                            transition:
                                              "background-color 0.2s ease",
                                            marginRight: "4px",
                                            borderRadius:
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "4px"
                                                : "0",
                                            padding:
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "0 2px"
                                                : "0",
                                          }}
                                          aria-live={
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "polite"
                                              : "off"
                                          }
                                        >
                                          {word}{" "}
                                        </span>
                                      ))}
                                  </div>
                                </div>
                              ) : (
                                <div className="w-[100%] text-xs pl-[10px] leading-[15px] mt-3">
                                  {comment?.message
                                    .split(/\s+/)
                                    .map((word, wordIdx) => (
                                      <span
                                        key={wordIdx}
                                        style={{
                                          backgroundColor:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "yellow"
                                              : "transparent",
                                          transition:
                                            "background-color 0.2s ease",
                                          marginRight: "4px",
                                          borderRadius:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "4px"
                                              : "0",
                                          padding:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "0 2px"
                                              : "0",
                                        }}
                                        aria-live={
                                          currentCommentId === idx &&
                                          wordIdx === currentWordIndex
                                            ? "polite"
                                            : "off"
                                        }
                                      >
                                        {word}{" "}
                                      </span>
                                    ))}
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-start mt-[10px]">
                            <div className="max-w-[87%] min-w-[30%] text-[#0B0B0B] p-[10px] bg-[#F4F4F4] rounded-[20px]">
                              <div className=" flex items-center justify-between">
                                <div className="flex items-center  gap-[10px] ">
                                  <div className="w-[33px] h-[33px]  flex justify-center items-center uppercase text-white text-[20px] bg-[#8B8B8B] rounded-full">
                                    {(() => {
                                      const sender = users?.[comment?.from];
                                      if (!sender) return "U";

                                      const loggedInRole =
                                        user?.roles?.[0]?.roleId;
                                      const senderRole =
                                        sender?.roles?.[0]?.roleId;

                                      const chosenName =
                                        loggedInRole === 1 || loggedInRole === 2
                                          ? sender.userName || sender.fullName
                                          : senderRole === 1 || senderRole === 2
                                            ? sender.userName
                                            : sender.fullName;

                                      return (
                                        chosenName?.[0]?.toUpperCase() || "U"
                                      );
                                    })()}
                                  </div>

                                  <div className="text-[15px] font-medium ">
                                    {(() => {
                                      const sender = users?.[comment?.from];
                                      if (!sender) return "Unknown";

                                      const loggedInRole =
                                        user?.roles?.[0]?.roleId;
                                      const senderRole =
                                        sender?.roles?.[0]?.roleId;

                                      const name =
                                        loggedInRole === 1 || loggedInRole === 2
                                          ? sender.userName || sender.fullName
                                          : senderRole === 1 || senderRole === 2
                                            ? sender.userName
                                            : sender.fullName;

                                      return name || "Unknown";
                                    })()}
                                  </div>
                                  {users &&
                                    !users[comment.from]?.role
                                      ?.toLowerCase()
                                      .includes("hospital") && (
                                      <div className="text-[10px] text-white px-2 py-1 rounded-full bg-[#017C71]">
                                        CC
                                      </div>
                                    )}
                                </div>
                                <div>
                                  <div className="flex items-center justify-between px-[10px]">
                                    <div className="text-[10px] text-[#969696]">
                                      {getFormattedDate(comment.createdAt)}
                                    </div>
                                    <div>
                                      <img
                                        src={SpeakerIcon}
                                        alt="speaker-icon"
                                        className="cursor-pointer"
                                        onClick={() =>
                                          handleSpeak(comment.message, idx)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {comment?.riskType ? (
                                <div>
                                  <div className="flex gap-2 items-start  mt-3">
                                    <div className="w-[40%]">
                                      <img
                                        src={HighRiskText}
                                        alt="high-risk-text-icon"
                                        className="w-full h-auto object-contain"
                                      />
                                    </div>
                                    <div className="w-[100%] text-xs pl-[10px] leading-[15px]">
                                      {comment?.message
                                        .split(/\s+/)
                                        .map((word, wordIdx) => (
                                          <span
                                            key={wordIdx}
                                            style={{
                                              backgroundColor:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "yellow"
                                                  : "transparent",
                                              transition:
                                                "background-color 0.2s ease",
                                              marginRight: "4px",
                                              borderRadius:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "4px"
                                                  : "0",
                                              padding:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "0 2px"
                                                  : "0",
                                            }}
                                            aria-live={
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "polite"
                                                : "off"
                                            }
                                          >
                                            {word}{" "}
                                          </span>
                                        ))}
                                    </div>
                                  </div>
                                  {/* buttons */}
                                  {!isViewingHistory && (
                                    <div className="flex justify-center items-center gap-3 text-[10px]">
                                      <div
                                        className="uppercase bg-[#017C57] text-white px-5 py-2 rounded-full"
                                        onClick={() =>
                                          handleCodeCommentAdd(
                                            "PLEASE PROCEED WITH EXISTING CODE",
                                            comment,
                                          )
                                        }
                                      >
                                        Proceed with existing code
                                      </div>
                                      <div
                                        className="uppercase bg-[#017C57] text-white px-5 py-2 rounded-full"
                                        onClick={() =>
                                          handleCodeCommentAdd(
                                            "PLEASE GET BEST SUITABLE CODE",
                                          )
                                        }
                                      >
                                        GET BEST SUITABLE CODE
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div className="w-[100%] text-xs pl-[10px] leading-[15px] mt-3">
                                  {comment?.message
                                    .split(/\s+/)
                                    .map((word, wordIdx) => (
                                      <span
                                        key={wordIdx}
                                        style={{
                                          backgroundColor:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "yellow"
                                              : "transparent",
                                          transition:
                                            "background-color 0.2s ease",
                                          marginRight: "4px",
                                          borderRadius:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "4px"
                                              : "0",
                                          padding:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "0 2px"
                                              : "0",
                                        }}
                                        aria-live={
                                          currentCommentId === idx &&
                                          wordIdx === currentWordIndex
                                            ? "polite"
                                            : "off"
                                        }
                                      >
                                        {word}{" "}
                                      </span>
                                    ))}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        <div ref={endOfMessagesRef} />
                      </div>
                    );
                  })}
              </div>

              {/* Composer / risk modal are read-only in history mode */}
              {!isViewingHistory && (
                <>
                  <div className="absolute bottom-1 left-0 w-full flex justify-center bg-white z-1 bg-transparent rounded-full">
                    <div
                      style={{
                        border: "1px solid #EAEAEA",
                        boxSizing: "border-box",
                      }}
                      className="w-[98%] mx-auto flex items-center justify-between p-1 rounded-full bg-white"
                    >
                      <textarea
                        ref={textareaRef}
                        placeholder="Type a message..."
                        className="w-[80%] text-[#555] font-semibold outline-none border-none ml-2 resize-none bg-transparent"
                        style={{
                          lineHeight: `${LINE_HEIGHT}px`,
                          minHeight: `${LINE_HEIGHT * MIN_LINES}px`,
                          maxHeight: `${LINE_HEIGHT * MAX_LINES}px`,
                        }}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={(e) => {
                          if (
                            e.key === "Enter" &&
                            !e.shiftKey &&
                            message.trim()
                          ) {
                            e.preventDefault();
                            handleCommentAdd();
                          }
                        }}
                      />
                      <div className="flex items-center gap-1">
                        {type != "document" &&
                          user?.roles[0]?.roleId != 1 &&
                          user?.roles[0]?.roleId != 2 && (
                            <img
                              src={RiskIcon}
                              alt="risk-icon"
                              height={32}
                              width={36}
                              onClick={() => setOpenRiskModal(true)}
                              className="cursor-pointer"
                            />
                          )}
                        <img
                          src={SpeechToText}
                          alt="speech-to-text-icon"
                          onClick={() => setIsListening(!isListening)}
                        />
                        <img
                          src={SendIcon}
                          alt="send-icon"
                          onClick={handleCommentAdd}
                        />
                      </div>
                    </div>
                  </div>
                  {openRiskModal && (
                    <div className="absolute top-0 left-0 h-full w-full flex justify-center items-center bg-[#017C5780] rounded-[30px]">
                      <div className="relative w-[95%] py-5  bg-[#FFFFFF80] rounded-[30px]">
                        <div
                          className="absolute top-1 right-2 cursor-pointer"
                          onClick={() => setOpenRiskModal(false)}
                        >
                          <Close />
                        </div>
                        <div className="p-[10px]">
                          {riskData &&
                            riskData?.map((risk, idx) => {
                              return (
                                <div
                                  key={idx}
                                  className="flex items-center gap-2 bg-white px-1 py-2 rounded-[8px] mb-2 cursor-pointer"
                                  onClick={() => handleRiskCommentAdd(risk)}
                                >
                                  <div>
                                    <img
                                      src={HighRiskText}
                                      alt="high-risk-text-icon"
                                    />
                                  </div>
                                  <div className="text-xs">{risk?.message}</div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
        <div className={`flex ${view ? "justify-center" : "justify-end"} mt-5`}>
          <div className="w-[60%] flex justify-center ">
            <HospitalCustomPaginaion
              page={currentIndex}
              setPage={setCurrentIndex}
              totalPages={activeData.length}
            />
          </div>
        </div>
      </div>

      <input
        type="file"
        onChange={(e) => reUploadImage(e)}
        style={{ display: "none" }}
        ref={reUploadFileRef}
        accept=".jpg,.jpeg,.png,"
      />
    </div>
  );
};

export default ImagesGalleryHospitalPersona;
